/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported credential kinds for v1.
 */
export enum TCCredentialKind {
    API_KEY = 'apiKey',
    BEARER = 'bearer',
    BASIC = 'basic',
    CUSTOM = 'custom',
    OAUTH = 'oauth',
}
